<template>
  <div class="hasPadding" style="margin-top: .533rem">
    <doc-info :is-wx="isWx" :user-obj="wxUserInfo"></doc-info>
    <div style="margin-top: .93rem">
      <item @click.native="jump('headlineDetail', '16207')">
        <div slot="centent" class="item_slot">
          <span style="color: #FA1413;font-size:.48rem ;">
            {{ wxUserInfo.userIntegral || 0 }}
          </span>
          <span style="color: #027CFA;font-size:.3733rem">积分商城</span>
        </div>
      </item>
      <item
        v-for="(item, index) in list"
        :key="index"
        @click.native="jump(item.jumpName)"
        :icons="item.icon"
        :name="item.name"
      ></item>
    </div>
  </div>
</template>
<script>
import DocInfo from './componetns/DocInfo.vue';
import Item from './componetns/Item.vue';
import { personal, getUsersData } from '@/api/ajax.js';
import { mapState } from 'vuex';
export default {
  name: '',
  data() {
    return {
      isWx: true,
      list: [
        // {name: '积分商城', jumpName: 'headlineDetail', id: '6fd7a332-a1f8-4d66-8dd1-b3d5b66f5081' , icon: ''},
        {
          name: '听课记录',
          jumpName: 'record',
          id: '',
          icon:
            'http://cdn.yxvzb.com/newWechat/image/%E4%B8%AA%E4%BA%BA%E4%B8%AD%E5%BF%83-%E5%90%AC%E8%AF%BE%E8%AE%B0%E5%BD%95@2x.png'
        },
        {
          name: '我的收藏',
          jumpName: 'collection',
          id: '',
          icon:
            'http://cdn.yxvzb.com/newWechat/image/%E4%B8%AA%E4%BA%BA%E4%B8%AD%E5%BF%83-%E6%88%91%E7%9A%84%E6%94%B6%E8%97%8F@2x.png'
        },
        {
          name: '每日任务',
          jumpName: 'task',
          id: '',
          icon:
            'http://cdn.yxvzb.com/newWechat/image/%E4%B8%AA%E4%BA%BA%E4%B8%AD%E5%BF%83-%E6%AF%8F%E6%97%A5%E4%BB%BB%E5%8A%A1@2x.png'
        }
        // {name: '任务提醒设置', jumpName: 'personalSwitch', id: '' , icon: 'http://cdn.yxvzb.com/newWechat/image/%E4%BB%BB%E5%8A%A1%E8%AE%BE%E7%BD%AE%E6%8F%90%E9%86%92@2x.png'},
      ]
    };
  },
  methods: {
    jump(name, id) {
      let routeObj = {
        name
      };
      if (id) {
        routeObj.params = { id };
      }
      this.$router.push(routeObj);
    }
  },
  computed: {
    ...mapState({
      wxUserInfo: state => state.wxUserInfo
    })
  },
  watch: {
    wxUserInfo: {
      immediate: true,
      async handler(v) {
        if (v) {
          const {
            data: { data }
          } = await getUsersData();
          // 医师不提供注销操作
          if (!data.lecturerId) {
            this.list.push({
              name: '账号注销',
              jumpName: 'PersonalLogOffApply',
              id: '',
              icon:
                'http://cdn.yxvzb.com/newWechat/image/%E4%B8%AA%E4%BA%BA%E4%B8%AD%E5%BF%83-%E6%AF%8F%E6%97%A5%E4%BB%BB%E5%8A%A1@2x.png'
            });
          }
        }
      }
    }
  },
  components: {
    DocInfo,
    Item
  },
  created() {
    if (this.$api.kernel() != 'wx') {
      this.isWx = false;
    }
  }
};
</script>
<style lang="less" scoped>
.item_slot {
  display: flex;
  flex: 1;
  /*padding: 0 .3rem;*/
  padding-left: 0.3rem;
  padding-right: 0.5rem;
  align-items: center;

  justify-content: space-between;
}
</style>
